export default from './comment-list';



// WEBPACK FOOTER //
// ./app/components/comment-list/index.js